import styled from 'styled-components'
import { flexbox, layout, margin, padding, position } from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, PX_BLUEPRINT } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div
  .attrs({
    pt: [30, 30, 70, 70, 200],
    pb: [0, 0, 400, 232],
    flexDirection: ['column-reverse', 'column-reverse', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  overflow: hidden;

  ${flexbox}
  ${padding}
`

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  max-width: ${BLUEPRINT_WIDTH}px;
  position: relative;
  z-index: 12;
`

export const DotsContainer = styled.div.attrs({
  bottom: [0, 0, -170, -128],
  left: [0, 0, 18, -40],
  display: ['none', 'none', 'flex'],
})`
  display: flex;
  position: absolute;
  z-index: 0;

  ${position}
  ${layout}
`

export const ContentHolder = styled.div.attrs({
  px: PX_BLUEPRINT,
})`
  display: flex;
  flex-direction: column;
  z-index: 1;
  position: relative;

  ${padding}
`

export const ImageHolder = styled.div.attrs({
  height: ['auto', 'auto', 660, 644, 772],
  width: [1, 1, 660, 704, 858],
  left: [0, 0, '40%', '40%', '40%', '45%'],
  position: ['relative', 'relative', 'absolute'],
})`
  bottom: 0;

  ${margin}
  ${layout}
  ${position}
`

export const StyledImage = styled.img`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: bottom;
  z-index: 12;
`
